import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import { useI18n } from '../../context/useI18n';

/**
 * Resumen cruzado Training + Food (orquestado por shell/core, sin fusionar BDs).
 */
export default function CoachClientOverviewCard({ userId }) {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError('');
    try {
      const r = await api.get(`/training/coach/clients/${userId}/overview`);
      setData(r.data?.data || null);
    } catch (e) {
      setData(null);
      setError(e.response?.data?.error || t('coach.overview_error', 'No se pudo cargar el resumen'));
    } finally {
      setLoading(false);
    }
  }, [userId, t]);

  useEffect(() => { load(); }, [load]);

  if (!userId) return null;
  if (loading) {
    return <div className="card training-follow-card training-light-island surface-readable ui-light-panel bg-white p-4 text-sm text-violet-900">Cargando resumen…</div>;
  }
  if (error) {
    return <div className="card p-4 text-sm text-red-700 bg-red-50 border border-red-200">{error}</div>;
  }
  if (!data) return null;

  const tl = data.traffic_light;
  const food = data.food || {};
  const train = data.training || {};
  const light = String(tl?.traffic_light || tl?.status || '').toLowerCase();
  const lightLabel = light === 'green' ? 'Verde' : light === 'yellow' ? 'Amarillo' : light === 'red' ? 'Rojo' : '—';

  return (
    <div className="card training-follow-card training-light-island surface-readable ui-light-panel bg-white p-4 space-y-3 text-violet-900">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <h3 className="font-bold text-sm uppercase tracking-wide">
            {t('coach.client_overview', 'Resumen Training + FOOD')}
          </h3>
          <p className="text-xs text-stone-600 mt-0.5">
            {train.user?.nombre || `Usuario #${userId}`}
          </p>
        </div>
        <button type="button" className="btn-secondary text-xs" onClick={load}>
          {t('common.refresh', 'Actualizar')}
        </button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
        <div>
          <p className="text-xs text-stone-500 uppercase">Semáforo</p>
          <p className="font-bold text-lg">{lightLabel}</p>
          <p className="text-xs text-stone-500">{tl?.adherence_pct != null ? `${tl.adherence_pct}%` : ''}</p>
        </div>
        <div>
          <p className="text-xs text-stone-500 uppercase">Último peso</p>
          <p className="font-bold text-lg">
            {food.weight_kg != null ? `${food.weight_kg} kg` : '—'}
          </p>
          <p className="text-xs text-stone-500">{food.weight_source || ''}</p>
        </div>
        <div>
          <p className="text-xs text-stone-500 uppercase">Fotos Training</p>
          <p className="font-bold text-lg">{train.photos_count ?? food.counts?.training_photos ?? 0}</p>
        </div>
        <div>
          <p className="text-xs text-stone-500 uppercase">Medidas FOOD</p>
          <p className="font-bold text-lg">{food.counts?.food_measures ?? 0}</p>
          <p className="text-xs text-stone-500">
            {food.both_paid ? 'both_paid' : 'sin dual'}
          </p>
        </div>
      </div>
      {food.wellness ? (
        <p className="text-xs text-stone-600">
          Bienestar: sueño {food.wellness.sleep_hours ?? '—'}h · energía {food.wellness.energy_level ?? '—'}/10 · estrés {food.wellness.stress_level ?? '—'}/10
        </p>
      ) : null}
    </div>
  );
}
